module.exports = __webpack_public_path__ + "static/img/right-num-row-3.cb616455.webp";